// CarteVirtuelle.js
import React, { useState } from 'react';
import MenuClient from '../Components/menuclient';

const CarteVirtuelle = () => {
  const [visible, setVisible] = useState(false);

  const infosCarte = {
    nom: "LEBEL ELOGE",
    numero: "5412 7512 3412 1234",
    expiration: "08/28",
    iban: "FR76 3000 6000 0112 3456 7890 189",
    bic: "AGRIFRPP",
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Carte virtuelle</h2>

      <div style={styles.card}>
        <div style={styles.chip}></div>
        <p style={styles.cardNumber}>
          {visible ? infosCarte.numero : "**** **** **** 1234"}
        </p>
        <div style={styles.cardDetails}>
          <div>
            <p style={styles.label}>Nom</p>
            <p style={styles.value}>{visible ? infosCarte.nom : "••••••••••••"}</p>
          </div>
          <div>
            <p style={styles.label}>Exp.</p>
            <p style={styles.value}>{infosCarte.expiration}</p>
          </div>
        </div>
      </div>

      <button onClick={() => setVisible(!visible)} style={styles.button}>
        {visible ? "Masquer les détails" : "Voir les détails de mon compte"}
      </button>

      {visible && (
        <div style={styles.infos}>
          <p><strong>Numéro complet :</strong> {infosCarte.numero}</p>
          <p><strong>Nom du titulaire :</strong> {infosCarte.nom}</p>
          <p><strong>IBAN :</strong> {infosCarte.iban}</p>
          <p><strong>BIC / SWIFT :</strong> {infosCarte.bic}</p>
        </div>
      )}

      <MenuClient />
    </div>
  );
};

const styles = {
  container: {
    padding: '20px',
    paddingBottom: '80px',
    fontFamily: 'Arial, sans-serif',
  },
  title: {
    fontSize: '20px',
    marginBottom: '20px',
  },
  card: {
    backgroundColor: '#0061A6',
    color: 'white',
    borderRadius: '16px',
    padding: '20px',
    position: 'relative',
    marginBottom: '20px',
  },
  chip: {
    width: '40px',
    height: '30px',
    backgroundColor: '#ccc',
    borderRadius: '6px',
    marginBottom: '20px',
  },
  cardNumber: {
    fontSize: '20px',
    letterSpacing: '2px',
    marginBottom: '15px',
  },
  cardDetails: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  label: {
    fontSize: '12px',
    color: '#ddd',
  },
  value: {
    fontSize: '14px',
    fontWeight: 'bold',
  },
  button: {
    backgroundColor: '#0061A6',
    color: 'white',
    padding: '12px',
    fontSize: '14px',
    borderRadius: '6px',
    border: 'none',
    cursor: 'pointer',
    width: '100%',
    marginBottom: '15px',
  },
  infos: {
    backgroundColor: '#f3f3f3',
    padding: '15px',
    borderRadius: '8px',
    lineHeight: '1.6',
    fontSize: '14px',
  }
};

export default CarteVirtuelle;
